import { useState } from "react";
import NavbarTop from "../components/NavbarTop";
import HeroSlider from "../components/HeroSlider";

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <NavbarTop onToggleMenu={() => setMenuOpen(true)} />
      <HeroSlider />
    </>
  );
}
